var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.67999 0.800293C4.94501 0.800293 5.15999 1.01522 5.15999 1.28029V4.64029H8.51999C8.78501 4.64029 8.99999 4.8552 8.99999 5.12029C8.99999 5.26532 8.9356 5.3953 8.83403 5.48324C8.75 5.55613 8.63999 5.60029 8.51999 5.60029H5.15999V8.96029C5.15999 9.22538 4.94501 9.44029 4.67999 9.44029C4.41496 9.44029 4.19999 9.22538 4.19999 8.96029V5.60029H0.839985C0.574987 5.60029 0.359985 5.38538 0.359985 5.12029C0.359985 4.8552 0.574987 4.64029 0.839985 4.64029H4.19999V1.28029C4.19999 1.01522 4.41496 0.800293 4.67999 0.800293Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.838fff35fa72addced4567d8d3e6d9ed.svg";
export { ForwardRef as ReactComponent };